import styled, { css } from "styled-components";
import media from "styled-media-query";

export const TabContainer = styled.div`
  ${({ theme }) => css`
    margin-top: 90px;
    width: 45%;
    min-width: 500px;

    .react-tabs__tab-list {
      border-bottom: 1px solid rgba(255, 255, 255, 0.12);
      display: flex;
      justify-content: space-around;
      
    }

    .react-tabs__tab {
      color: ${theme.colors.text};
      width: 50%;
      display: flex;
      justify-content:center;
      align-items: center;
    }

    .react-tabs__tab--selected {
      background: inherit;
      border: 0px;
      color: ${theme.colors.text};

      font-weight: 500;
      line-height: 1.35;
      white-space: normal;
      letter-spacing: 0.02857em;
      border-bottom: 3px solid ${theme.colors.primary_light};
    }
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    max-width: 1400px;
    padding: 30px;

    header {
      width: 64%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      ${media.lessThan("large")`
        flex-direction: column;
        align-items: flex-start;

        & > div:last-of-type {
          margin-top: 20px;
          margin-left: 0;
        }
      `}

      h1 {
        font-size: ${theme.font.sizes.large};
        color: ${theme.colors.title};
        font-weight: ${theme.font.bold};
        margin-left: 30px;
      }

      & > div {
        display: flex;
        align-items: center;
      }

      & > div:last-of-type {
        width: 45%;
        min-width: 300px;
      }
    }
  `}
`;

export const Content = styled.div`
  width: 46%;
  min-height: 80vh;
  min-width: 470px;
  margin-top: 50px;

  & > div:first-of-type {
    margin: 20px 0 30px;
  }
`;


